import { render, staticRenderFns } from "./data-cattle-slaughter.vue?vue&type=template&id=353bd609&scoped=true"
import script from "./data-cattle-slaughter.vue?vue&type=script&lang=js"
export * from "./data-cattle-slaughter.vue?vue&type=script&lang=js"
import style0 from "./data-cattle-slaughter.vue?vue&type=style&index=0&id=353bd609&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353bd609",
  null
  
)

export default component.exports